'use es6';

export var ROOT = '/';
export var TESTS = '/tests';
export var ERROR = '/error';